import ScannerUserGuide from './ScannerUserGuide';

export default ScannerUserGuide;
